import React from 'react';
import PropTypes from 'prop-types';

function Switch({ children, status }) {
  let component = null;
  let defaultComponent = null;
  React.Children.forEach(children, (child) => {
    if (child.props.default) {
      defaultComponent = child;
    }
    if (child.props.value === status) {
      component = child;
    }
    if (Array.isArray(child.props.value) && child.props.value.includes(status)) {
      component = child;
    }
  });
  return component || defaultComponent;
}

Switch.propTypes = {
  status: PropTypes.string.isRequired,
};

export default Switch;
